import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from "@angular/core";
@Directive({
  selector: "img[appImageFallback]",
})
export class ImageFallbackDirective {
  @Input() fallbackImage: string;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private renderer: Renderer2
  ) {}

  @HostListener("error")
  onError() {
    this.updateUrl();
  }

  updateUrl() {
    const img = this.el.nativeElement;
    // не зацикливаемся, если фоллбэк тоже не загрузился
    if (!this.fallbackImage || img.getAttribute("src") === this.fallbackImage) {
      return;
    }
    this.renderer.setAttribute(img, "src", this.fallbackImage);
  }
}
